class LoadMoreSearchResults {
    buttons: NodeListOf<HTMLButtonElement>;
    lastButtonClicked?: string;

    constructor() {
        this.buttons = document.querySelectorAll(
            ".ajax-search-page-next-button",
        );
        this.addListeners();
    }

    addListeners() {
        this.buttons.forEach((button) => {
            button.addEventListener("click", async () => {
                this.lastButtonClicked = button.dataset.fetchType;
                await this.loadMoreResults(button);
                this.handleFocus();
            });
        });
    }

    async loadMoreResults(button: HTMLButtonElement) {
        const url = button.dataset.fetchUrl;
        if (!url) return;

        const screenreaderMessage = document.querySelector<HTMLDivElement>(
            `div[data-sr-message-type="${this.lastButtonClicked}"]`,
        );
        if (screenreaderMessage) {
            const message =
                screenreaderMessage.dataset.message ?? "Laddar fler resultat";

            screenreaderMessage.textContent = message;
        }

        button.classList.add("hide");
        const spinner = document.querySelector<HTMLDivElement>(
            `div[data-spinner-type="${this.lastButtonClicked}"]`,
        );
        spinner?.classList.add("show");

        try {
            const response = await fetch(url);
            const text = await response.text();
            const parser = new DOMParser();
            const doc = parser.parseFromString(text, "text/html");

            const newContent = doc.querySelector(
                ".ajax-result-section",
            )?.innerHTML;
            if (newContent) {
                spinner?.classList.remove("show");
                if (screenreaderMessage) screenreaderMessage.textContent = "";
                button.classList.remove("hide");
                document.querySelector(".ajax-result-section")!.innerHTML =
                    newContent;
                this.refresh();
            }
        } catch (error) {
            console.error("Failed to load content:", error);
        }
    }

    refresh() {
        this.buttons = document.querySelectorAll(
            ".ajax-search-page-next-button",
        );
        this.addListeners();
    }

    handleFocus() {
        const buttonToFocus = document.querySelector<HTMLButtonElement>(
            `button[data-fetch-type="${this.lastButtonClicked}"]`,
        );

        if (buttonToFocus) {
            buttonToFocus.focus({ preventScroll: true });
        } else {
            const headerToFocus = document.querySelector<HTMLHeadingElement>(
                `h2[data-header-type="${this.lastButtonClicked}"]`,
            );
            headerToFocus?.setAttribute("tabindex", "-1");
            headerToFocus?.focus({ preventScroll: true });
        }
    }
}

export default LoadMoreSearchResults;
